import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { EvaluationType } from "../entities/evaluation-type";

@Injectable()
export class EvaluationTypeService extends BaseCrudService<EvaluationType>{

    public uri = '/api/evaluationType/';

    constructor(injector: Injector) {
      super(injector);
     //console.log('Instance EvaluationTypeService');
    }

    buildSentence(entity?: EvaluationType, event?: LazyLoadEvent): HttpParams {
        if (entity) {
          let query = '';
          query = query.concat(
            entity.code ?
              `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.name ?
              `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }
    
        if (event) {
          const page = ((event.first + event.rows) / event.rows - 1).toString();
          const size = event.rows.toString();
          this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
          this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
      }

}


// WEBPACK FOOTER //
// ./src/app/core/services/evaluation-type.service.ts